import "./AISearchOptimisation.module.css";
import Header from "@/reusable_sections/Header";
import Aisearch from "./sections/Aisearch";
import Aibenefits from "./sections/Aibenefits";
import Aisearchlandscape from "./sections/Aisearchlandscape";
import AiVsTraditional from "./sections/AiVsTraditional";
import AiPlatforms from "./sections/AiPlatforms";
import GeoStrategy from "./sections/GeoStrategy";
import AudienceDifferentiators from "./sections/AudienceDifferentiators";
import Aireadiness from "./sections/Aireadiness";
import AuditMeasurement from "./sections/AuditMeasurement";
import Pricing from "./sections/Pricing";
import Faq from "./sections/Faq";
import Cta from "./sections/Cta";
import Footer from "@/reusable_sections/Footer";
export default function AISearchOptimisationPage() {
  return <div>
      <Header />
      <Aisearch />
      <Aibenefits />
      <Aisearchlandscape />
      <AiVsTraditional />
      <AiPlatforms />
      <GeoStrategy />
      <AudienceDifferentiators />
      <Aireadiness />
      <AuditMeasurement />
      <Pricing />
      <Faq />
      <Cta />
      <Footer />
    </div>;
}